import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import * as appPropTypes from '../../../appPropTypes';
import * as chatActions from '../../../../store/actions/chatActions';
import * as fileActions from '../../../../store/actions/fileActions';
import Message from './Item/Message';
import File from './Item/File';
import EmptyAvatar from '../../../../images/avatar-empty.jpeg';
const styles = (theme) =>
	({
		root :
	{
		height        : '100%',
		display       : 'flex',
		flexDirection : 'column',
		alignItems    : 'flex-end',
		overflowY     : 'auto',
		width         : '100%',
		padding       : '8px'
	},
		'@global' : {
			'*' : {
				'scrollbar-width' : 'thin'
			},
			'*::-webkit-scrollbar' : {
				width  : '5px',
				height : '5px'
			},
			'*::-webkit-scrollbar-track' : {
				background : 'white'

			},
			'*::-webkit-scrollbar-thumb' : {
				backgroundColor : '#999999'
			}
		},
		'MsgContainer' :
	{
		backgroundColor : 'red'
	},
		buttonGoToNewest :
	{
		position     : 'fixed',
		borderRadius : '50px',
		'&.show'     :
		{
			transition : 'opacity 0.5s',
			opacity    : '1'
		},
		'&.hide' :
		{
			transition : 'opacity 0.5s',
			opacity    : '0'
		},
		'&.asc' : {
			bottom : '100px'
		},
		'&.desc' : {
			top : '130px'
		}
	},
		noMsg : {
			width          : '100%',
			height         : '100%',
			display        : 'flex',
			flex           : 'none',
			flexDirection  : 'column',
			alignItems     : 'center',
			justifyContent : 'center'
		}
	});

class MessageList extends React.Component
{
	constructor(props)
	{
		super(props);

		this.refList = React.createRef();

		this.currWidth = 0;
	}

	componentDidMount()
	{
		this.refList.current.addEventListener('scroll', this.handleSetScrollEnd);

		this.refList.current.addEventListener('scroll', this.handleIsMessageSeen);
		this.scrollToBottom();

	}

	componentDidUpdate(prevProps)
	{
		// if (prevProps.chat.messages.length !== this.props.chat.messages.length)
		// {
		// 	this.scrollToBottom();
		// }
		if (prevProps.chat.count !== this.props.chat.count)
		{
			this.isMessageSeen();
		}

		if (this.props.chat.isScrollEnd)
		{
			this.handleGoToNewest();
		}

		if (prevProps.chat.order !== this.props.chat.order)
		{
			this.setIsScrollEnd();

			this.handleGoToNewest();
		}
	}

	handleSetScrollEnd = () =>
	{
		this.setIsScrollEnd();
	}

	handleIsMessageSeen = (e) =>
	{
		this.isMessageSeen(e);
	}

	setWidth(el)
	{
		const prev = el.previousSibling;

		const curr = el;

		const prevName = prev?.getAttribute('data-name');

		const currName = curr?.getAttribute('data-name');

		const currWidth = curr.offsetWidth;

		if (currName !== prevName)
		{
			this.currWidth = currWidth;

			curr.style.minWidth = `${this.currWidth}px`;
		}
		else
		if (currWidth > this.currWidth)
		{
			this.currWidth = currWidth;

			prev.style.minWidth = `${this.currWidth}px`;

			curr.style.minWidth = `${this.currWidth}px`;

			this.forceUpdate();
		}
		else
		{
			curr.style.minWidth = `${this.currWidth}px`;
		}
	}

	setIsScrollEnd = () =>
	{
		let isScrollEnd = undefined;

		if (this.props.chat.order === 'asc')
			isScrollEnd = (
				Math.abs(
					Math.floor(this.refList.current?.scrollTop) +
					this.refList.current?.offsetHeight -
					this.refList.current?.scrollHeight

				) < 2
			);
		else
		if (this.props.chat.order === 'desc')
			isScrollEnd = (this.refList.current.scrollTop === 0 ? true : false);

		this.props.setIsScrollEnd(isScrollEnd);

	}

	isMessageSeen = () =>
	{
		const list = this.refList.current;

		const listRect = list?.getBoundingClientRect();

		const items = [ ...list?.childNodes ];

		console.log('items===', items);

		let isSeen = null;

		items.forEach((item) =>
		{
			const itemRect = item?.getBoundingClientRect();

			if (this.props.chat.order === 'asc')
			{
				isSeen = itemRect.top <= listRect.bottom;
			}
			else
			{
				isSeen = itemRect.top >= listRect.top;
			}

			if (item.tagName === 'DIV')
			{
				if (isSeen && item.dataset.isseen === 'false')
				{
					this.props.setIsMessageRead(item.dataset.time, true);
					this.props.setIsFileRead(item.dataset.time, true);
				}
			}
		});
	}

	// scrollToBottom = () =>
	// {
	// 	// Set scrollTop to the scrollHeight of the container
	// 	this.refList.current.scrollTop.scrollTop = this.refList.current.scrollTop.scrollHeight;
	// };

	scrollToBottom()
	{
		if (this.refList.current)
		{
			this.refList.current.scrollTop = this.refList.current.scrollHeight;

			this.handleIsMessageSeen();
		}
	}

	handleGoToNewest = () =>
	{
		if (this.props.chat.order === 'asc')
			this.refList.current.scrollTop = this.refList.current.scrollHeight;
		else
		if (this.props.chat.order === 'desc')
			this.refList.current.scrollTop = 0;
	}

	render()
	{
		const {
			chat,
			myPicture,
			classes,
			files,
			me,
			peers,
			intl,
			chatBackgroundColor,
			setIsPlaying,
			isPlaying, preview, setPreview, setFileUrl, fileUrl
		} = this.props;

		const items = [ ...chat.messages, ...files.files ];

		items.sort((a, b) => (a.time < b.time ? -1 : 1));

		if (items.length > 0)
		{
			if (chat.order === 'asc')
				items.sort();
			else
			if (chat.order === 'desc')
				items.reverse();
		}

		return (
			<React.Fragment>
				<div id='chatList' className={classes.root} ref={this.refList}>
					{/* <Button
						variant='contained'
						color='primary'
						size='small'
						onClick={() => this.handleGoToNewest()}
						className={
							classnames(
								classes.buttonGoToNewest,
								chat.countUnread > 0 ? 'show': 'hide',
								chat.order === 'asc' ? 'asc' : 'desc'
							)
						}
						endIcon={
							(chat.order === 'asc' ?
								<ChevronLeftIcon
									style={{
										color     : 'white',
										transform : 'rotate(270deg)'
									}}
								/> :
								<ChevronLeftIcon
									style={{
										color     : 'white',
										transform : 'rotate(90deg)'
									}}
								/>
							)
						}
					>
						( {chat.countUnread} )&nbsp;
						<FormattedMessage
							id='label.chatNewMessages'
							defaultMessage='New messages'
						/>
					</Button> */}

					{items.length === 0
						? (<div className={classes.noMsg}>
							{/* {intl.formatMessage({
								id: 'label.chatNoMessages',
								defaultMessage: 'No messages'
							})} */}
							<img src='icons/noMsg.svg' alt='noMsg' />
							<span className='lHdng pdngTMD'>{intl.formatMessage({
								id             : 'label.chatNoMessages',
								defaultMessage : 'No messages, yet'
							})}</span>

						</div>)
						:
						items.map((item, index) =>
						{
							const prev = (index > 0) ?
								`${items[index - 1].peerId}-${items[index - 1].name}` : null;

							const curr = `${item.peerId}-${item.name}`;

							const next = (index < items.length - 1) ?
								`${items[index + 1].peerId}-${items[index + 1].name}` : null;

							let format = null;

							if (curr !== prev && curr !== next)
								format = 'single';
							else if (curr !== prev && curr === next)
								format = 'combinedBegin';
							else if (curr === prev && curr === next)
								format = 'combinedMiddle';
							else if (curr === prev && curr !== next)
								format = 'combinedEnd';

							if (item.type === 'message')
							{
								const message = (
									<Message
										// refMessage={
										// 	(el) => el && this.setWidth(
										// 		el
										// 	)
										// }
										key={item.key}
										time={item.time}
										avatar={(item.sender === 'response' ?
											item.picture : myPicture) || ''
										}
										name={item.name}
										text={item.text}
										isseen={item.isRead}
										sender={me.id === item.peerId ?
											'client' : item.sender
										}
										self={item.sender === 'client'}
										format={format}
										chatBackgroundColor={chatBackgroundColor}
									/>);

								return message;
							}

							else if (item.type === 'file')
							{

								// let displayName;

								let filePicture;

								if (me.id === item.peerId)
								{
									/*
									displayName = intl.formatMessage({
										id             : 'room.me',
										defaultMessage : 'Me'
									});
									*/

									filePicture = me.picture;
								}
								else if (peers[item.peerId])
								{
									// displayName = peers[item.peerId].displayName;

									filePicture = peers[item.peerId].picture;
								}
								else
								{
									/*
									displayName = intl.formatMessage({
										id             : 'label.unknown',
										defaultMessage : 'Unknown'
									});
									*/
								}

								return (
									<File
										refMessage={
											(el) => el && this.setWidth(
												el
											)
										}
										file={item}
										key={item.key}
										time={item.time}
										url={item.url}
										name={item.name}
										avatar={(item.sender === 'response' ?
											item.picture : myPicture) || ''
										}
										isseen={item.isRead}
										sender={me.id === item.peerId ?
											'client' : item.sender
										}
										self={item.sender === 'client'}
										fileType={item.fileType}
										format={format}
										fileName={item.fileName}
										chatBackgroundColor={chatBackgroundColor}
										index={index}
										setIsPlaying={setIsPlaying}
										isPlaying={isPlaying}
										preview={preview}
										setPreview={setPreview}
										setFileUrl={setFileUrl}
										fileUrl={fileUrl}
									/>
								);

							}

							return 0;
						})
					}

				</div>
			</React.Fragment>
		);
	}
}

MessageList.propTypes =
{
	chat                : PropTypes.any,
	myPicture           : PropTypes.string,
	classes             : PropTypes.object.isRequired,
	files               : PropTypes.any.isRequired,
	me                  : appPropTypes.Me.isRequired,
	peers               : PropTypes.object.isRequired,
	intl                : PropTypes.object.isRequired,
	setIsScrollEnd      : PropTypes.func.isRequired,
	setIsMessageRead    : PropTypes.func.isRequired,
	setIsFileRead       : PropTypes.func.isRequired,
	chatBackgroundColor : PropTypes.string.isRequired,
	setIsPlaying        : PropTypes.any,
	isPlaying           : PropTypes.any,
	preview             : PropTypes.any,
	setPreview          : PropTypes.any,
	fileUrl             : PropTypes.any,
	setFileUrl          : PropTypes.any
};

const mapStateToProps = (state) =>
	({
		chat                : state.chat,
		myPicture           : state.me.picture,
		me                  : state.me,
		peers               : state.peers,
		files               : state.files,
		chatBackgroundColor : state.appearance.chatBackgroundColor

	});

const mapDispatchToProps = (dispatch) =>
	({
		setIsScrollEnd : (flag) =>
		{
			dispatch(chatActions.setIsScrollEnd(flag));
		},
		setIsMessageRead : (id, isRead) =>
		{
			dispatch(chatActions.setIsMessageRead(id, isRead));
		},
		setIsFileRead : (id, isRead) =>
		{
			dispatch(fileActions.setIsFileRead(id, isRead));
		}
	});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.chat === next.chat &&
				prev.files === next.files &&
				prev.me.picture === next.me.picture &&
				prev.me === next.me &&
				prev.peers === next.peers &&
				prev.appearance.chatBackgroundColor ===
				next.appearance.chatBackgroundColor
			);
		}
	}
)(withStyles(styles)(injectIntl(MessageList)));
